import { render, staticRenderFns } from "./audit-renewal-orders.vue?vue&type=template&id=4d837f48&scoped=true"
import script from "./audit-renewal-orders.vue?vue&type=script&lang=js"
export * from "./audit-renewal-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d837f48",
  null
  
)

export default component.exports